import { render, staticRenderFns } from "./SettingEmployment.vue?vue&type=template&id=c70ac5b8&"
import script from "./SettingEmployment.vue?vue&type=script&lang=js&"
export * from "./SettingEmployment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports